export default "__VITE_ASSET__DZji_A8c__"